import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch past orders for a customer
 * @param {string} customerId - Customer ID
 * @param {string} filter - Order filter type (e.g., "delivery")
 * @returns {Promise<Object>} - Response data from the API
 */
export const getPastOrdersApi = async (customerId, filter = "delivery") => {
  try {
    const response = await apiClient.get(
      `${API_ENDPOINTS.PAST_ORDERS}?customer_id=${customerId}`
    );
    return response.data; // Return the fetched data
  } catch (error) {
    handleApiError(error); // Handle API errors centrally
    throw error;
  }
};
